import React, { useState } from "react"
import {
  Flex, Box, Text,
} from "@chakra-ui/react"
import UserWithAvatar from "components/elements/UserWithAvatar"
import Badge from "components/elements/Badge"
import Button from "components/Buttons/Button"
import EditExhibitor from "modals/EditExhibitor/EditExhibitor"

type StatusLabel = "Active" | "Invited"

const STATUS_BADGE_COLOR: Record<StatusLabel, string> = {
  Active: "green.400",
  Invited: "orange.400",
}

type Props = {
  eventId: string
  exhibitor: {
    name?: string
    email: string
    photoUrl?: string
    sourceLabel?: "Organizer-Paid" | "Exhibitor-Paid"
    statusLabel?: StatusLabel
    invitedAt?: string
    activatedAt?: string
    licenseId?: number
    inviteUrl?: string
    onRevoke?: () => void | Promise<void>
    onResend?: () => void | Promise<void>
    onUpdateName?: (name: string) => void | Promise<void>
  }
  licenseFee: number
}

const ExhibitorListItem = ({
  eventId,
  exhibitor: {
    email, photoUrl, name, sourceLabel, statusLabel, invitedAt, activatedAt,
    licenseId, inviteUrl, onRevoke, onResend, onUpdateName,
  },
  licenseFee,
}: Props) => {
  const [showDetail, setShowDetail] = useState(false)

  const useDetailModal = Boolean(sourceLabel && statusLabel)

  const handleDelete = async () => {
    await onRevoke?.()
    setShowDetail(false)
  }

  return (
    <Flex justifyContent="space-between" alignItems="center" px={6} py={5}>
      <UserWithAvatar name={name} email={email} photoUrl={photoUrl} />
      <Text w={1 / 5}>{sourceLabel}</Text>
      <Box w={1 / 5}>
        {statusLabel && <Badge color={STATUS_BADGE_COLOR[statusLabel]}>{statusLabel}</Badge>}
      </Box>
      <Box w={20} flexShrink={0} textAlign="right">
        {useDetailModal && (
          <Button variant="outline" size="sm" onClick={() => setShowDetail(true)}>Edit</Button>
        )}
      </Box>
      {showDetail && sourceLabel && statusLabel && (
        <EditExhibitor
          eventId={eventId}
          licenseFee={licenseFee}
          exhibitor={{
            email, name, sourceLabel, statusLabel, invitedAt, activatedAt, licenseId, inviteUrl,
          }}
          onDelete={handleDelete}
          onResend={onResend}
          onUpdateName={onUpdateName}
          onHide={() => setShowDetail(false)}
        />
      )}
    </Flex>
  )
}

export default ExhibitorListItem
